import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import { COOKIESPREFIX } from './config.js';
import { Login, setuserData } from './actions/actions'
import NavBar from './components/NavBar';
//pages
import PageNotFound from './screens/PageNotFound'
import Home from './screens/Home';
import AboutUs from './screens/AboutUs';
import Register from './screens/newlanding/screens/Register.js'
import EventDetails from './screens/EventDetails';
import EventDetails1 from './screens/EventDetails1.js';
import EventDetails2 from './screens/EventDetails2.js';
import Privacy from './screens/Privacy';
import EventApproval from './screens/EventApproval.js';
import DeleteAccountDetails from './screens/DeleteAccountDetails.js';
import MembershipApproval from './screens/MembershipApproval.js';
import CMS from './screens/cms/Router.js';
import TSHOP from './screens/tshop/Router.js';
import NewLanding from './screens/newlanding/Router.js'
import RegistrationForm from './screens/RegistrationForm.js';
import RegistrationForm_SP from './screens/RegistrationForm_SP.js';
import Purchase from './screens/Purchase.js';
import Event from './screens/Events.js';
import PurchaseMessages from './screens/PurchaseMessages';
import TopupPage from './screens/Topup.js';
import Form from './screens/Form.js';
// import Mpti from './screens/Mpti.js';
import MessageSuccessful from './screens/MessageSuccessful.js';
import RegistrationFormLuckyDraw from './screens/RegistrationFormLuckyDraw.js';
import { getProfile, validToken } from './services/users.js';
import RegistrationForm2026 from './screens/RegistrationForm2026.js';
import QRcode from './screens/QRcode.js';


function App(props) {
  const [cookies, setCookie, removeCookie] = useCookies([`${COOKIESPREFIX}_cred`, `${COOKIESPREFIX}_token`]);
  const location = useLocation()
  useEffect(() => {
    // console.log(props)
    async function check_token() {
      let login_cred = cookies[`${COOKIESPREFIX}_cred`];
      let token = cookies[`${COOKIESPREFIX}_token`];
      if (token && login_cred) {
        let res = await validToken(token)
        if (res.errno === 0 && login_cred.email && login_cred.usertype) {
          props.dispatch(Login(true, token, login_cred.usertype, login_cred.email))
          updateUserData(token)
        }
        //props.dispatch(Login(true, token, login_cred.usertype, login_cred.username))
      } else {
        try {
          removeCookie(`${COOKIESPREFIX}_token`, '/')
        } catch (e) {
          console.log(e)
        }
      }
    }
    check_token()
  }, [])

  const updateUserData = async (token) => {
    let result = await getProfile(token)
    if (result?.result) {
      props.dispatch(setuserData(result.result))
    }
  }

  // return (
  //   <div className="flex full-viewport-height flex flex-col" style={{ fontFamily: 'Oxygen', letterSpacing: 1.05 }}>
  //     <Mpti />
  //   </div>
  // );
  return (
    <div className="flex full-viewport-height flex flex-col" style={{ fontFamily: 'Oxygen', letterSpacing: 1.05 }}>
      <NavBar />
      <Routes >
        <Route path="/" element={<Home />} />
        <Route path="/cms/*" element={<CMS />} />
        <Route path="/tshop/*" element={<TSHOP />} />
        <Route path="/newlanding/*" element={<NewLanding />} />
        <Route path="/home" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/register" element={<Register />} />
        <Route path='/event' element={<EventDetails />} />
        <Route path='/event1' element={<EventDetails1 />} />
        <Route path='/event2' element={<EventDetails2 />} />
        <Route path='/events' element={<Event />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/google-delete-account-info' element={<DeleteAccountDetails />} />
        <Route path='/privacy.html' element={<Privacy />} />
        <Route path='/admin/event' element={<EventApproval />} />
        <Route path='/admin/membership' element={<MembershipApproval />} />
        <Route path="/registration-form/:id" element={<RegistrationForm />} />
        <Route path="/registration-form-sp/:id" element={<RegistrationForm_SP />} />
        <Route path="/registration-form-2026" element={<RegistrationForm2026 />} />
        <Route path="/registration-hkitc-2026" element={<RegistrationForm2026 />} />
        <Route path="/form/:id" element={<Form />} />
        <Route path="/purchase/:id" element={<Purchase />} />
        <Route path="/messages" element={<PurchaseMessages />} />
        <Route path='/top-up' element={<TopupPage />} />
        <Route path='/message-successful' element={<MessageSuccessful />} />
        <Route path="/lucky-draw-2025" element={<RegistrationFormLuckyDraw />} />
        <Route path='/qrcode/:id' element={<QRcode />} />
        <Route path='/index.html' element={<Home />} />
        {/* <Route path="/login" element={<LoginPage />} />
        <Route path="/records" element={<Record />} /> */}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)

